import I18n from 'i18n-js'

export const adPreviewTypes = {
  DESKTOP_FEED_STANDARD: {
    type: 'DESKTOP_FEED_STANDARD',
    title: I18n.t('content.desktopFeed'),
    symbol: 'facebook',
    width: 502,
    height: 720,
    socialPreviewType: 'facebook/ad/desktop',
  },
  MOBILE_FEED_STANDARD: {
    type: 'MOBILE_FEED_STANDARD',
    title: I18n.t('content.mobileFeed'),
    symbol: 'facebook',
    width: 320,
    height: 534,
    socialPreviewType: 'facebook/ad/mobile',
  },
  INSTAGRAM_STANDARD: {
    type: 'INSTAGRAM_STANDARD',
    title: I18n.t('content.instagramPreview'),
    symbol: 'instagram-square',
    width: 320,
    height: 600,
    socialPreviewType: 'instagram/ad',
  },
  MOBILE_INTERSTITIAL: {
    type: 'MOBILE_INTERSTITIAL',
    title: I18n.t('content.audienceNetwork'),
    symbol: 'fb-audience',
    width: 322,
    height: 664,
    socialPreviewType: 'facebook/ad/audienceNetworkNative',
  },
  FACEBOOK_STORY_MOBILE: {
    type: 'FACEBOOK_STORY_MOBILE',
    title: I18n.t('content.facebookStory'),
    symbol: 'facebook',
    socialPreviewType: 'facebook/ad/story',
  },
  INSTAGRAM_STORY: {
    type: 'INSTAGRAM_STORY',
    title: I18n.t('content.instagramStory'),
    symbol: 'instagram-square',
    socialPreviewType: 'instagram/ad/story',
  },
  MESSENGER_MOBILE_STORY_MEDIA: {
    type: 'MESSENGER_MOBILE_STORY_MEDIA',
    title: I18n.t('content.messengerStory'),
    symbol: 'fb-messenger',
    width: 325,
    height: 600,
    socialPreviewType: 'messenger/ad/story',
  },
}

export const adPreviewStyles = Object.values(adPreviewTypes).reduce(
  (acc, cur) => {
    if (cur.width) {
      return {
        ...acc,
        [cur.type]: {
          '& iframe': {
            width: cur.width,
            height: cur.height,
          },
        },
      }
    }
    return acc
  },
  {},
)

export const validAdPreviewTypes = ({ targetingInfo, platforms }) => {
  const isStory = [
    'facebook_positions',
    'instagram_positions',
    'messenger_positions',
  ].some((key) => {
    if (targetingInfo[key]) {
      return targetingInfo[key][0] === 'story'
    }
    return false
  })

  const validTypes = []
  if (platforms.includes('facebook')) {
    isStory
      ? validTypes.push(adPreviewTypes.FACEBOOK_STORY_MOBILE)
      : validTypes.push(
          adPreviewTypes.DESKTOP_FEED_STANDARD,
          adPreviewTypes.MOBILE_FEED_STANDARD,
        )
  }
  if (platforms.includes('instagram')) {
    isStory
      ? validTypes.push(adPreviewTypes.INSTAGRAM_STORY)
      : validTypes.push(adPreviewTypes.INSTAGRAM_STANDARD)
  }

  if (platforms.includes('audience_network')) {
    validTypes.push(adPreviewTypes.MOBILE_INTERSTITIAL)
  }

  if (platforms.includes('messenger')) {
    validTypes.push(adPreviewTypes.MESSENGER_MOBILE_STORY_MEDIA)
  }

  return validTypes
}
